import ApiService from './api.service.js';

export default {
  async getPublicKey() {
    return await ApiService.get('/payments');
  },
  async createPayment(paymentData) {
    return await ApiService.post('/payments', paymentData);
  },
  async createPaymentIntent(intentData) {
    return await ApiService.post('/payments/intent', intentData);
  },
  createCustomerPortalSession(customerId, returnUrl) {
    return ApiService.post('/payments/customers/portal-session', {
      customerId,
      returnUrl: returnUrl || window.location.href
    });
  }
};
